import React from 'react'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import { fetchSets, addSets, sortSets, searchSets } from "../../actions/settings"
import SetsPtypeItem from "./SetsPtypeItem"
import SettingsForm from './SettingsForm'

class SetsPtype extends SettingsForm {

  modelName = 'ptype'

  newItem = {
    ptype_desc: '',
    ptype_active: 1
  };

  render() {
    if(isEmpty(this.props.ptypes.data)){
      return(<div>Не загружены данные</div>);
    }
    const ptypes = this.props.ptypes.data;
    const { search, sort } = this.props.ptypes;
    const { data, errors } = this.state;

    var fltrPtypes = [];
    for(var key in ptypes){
      if(ptypes.hasOwnProperty(key)){
        const active = ptypes[key].ptype_active === 1;
        var found = true;
        if(search !== ''){
          const searchValue = "" + ptypes[key].ptype_desc;
          found = searchValue.toLowerCase().indexOf(search) !== -1;
        }
        if(active && found){
          fltrPtypes.push(ptypes[key]);
        }
      }
    }

    const srtPtypes = fltrPtypes.sort( (a, b) => {
      if(a[sort.field] < b[sort.field])
         return sort.asc ? -1 : 1
      if(a[sort.field] > b[sort.field])
         return sort.asc ? 1 : -1
      if(a.ptype_id < b.ptype_id)
         return sort.asc ? -1 : 1
      if(a.ptype_id > b.ptype_id)
         return sort.asc ? 1 : -1
      return 0
    });

    const mappedPtypes = srtPtypes ? srtPtypes.map(ptype =>
      <SetsPtypeItem key={ptype.ptype_id}
        data={ptype}
      />
    ) : [];

    const addNew = this.state.adding ?
      <tr>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.ptype_desc}
              name="ptype_desc"
              onChange={this.updateInput}
              placeholder="Название"
              autoFocus
            />
          </div>
          <div className="form-inline">
            <button  type="button" className="btn btn-success"
              onClick={this.saveItem} title="Сохранить">
              <span className="glyphicon glyphicon-save"></span>
            </button>{" "}
            <button type="button" className="btn btn-default"
              onClick={this.cancelAdding} title="Отменить">
              <span className="glyphicon glyphicon-remove"></span>
            </button>
          </div>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </td>
      </tr>
      :[];


    return (
      <div>
        <h3 className="pull-right">Настройка типов площадок</h3>
        <div className="form-group form-inline">
          <button className="btn btn-primary" onClick={this.startAdding}>Создать</button>
          {" "}
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch} />
            <div className="input-group-btn">
              <button
                type="button"
                className="btn btn-default"
                onClick={this.clearSearch}
                title="Очистить поиск">
                X
              </button>
            </div>
          </div>{" "}
          <div className="input-group">{fltrPtypes.length} записей</div>
        </div>
        <table className="table table-striped table-hover sticky-50">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th onClick={() => {this.handleSort('ptype_desc',this)}}>Название</th>
            </tr>
          </thead>
          <tbody>
            {addNew}
            {mappedPtypes}
            <tr onClick={this.startAdding}>
              <td><u>Нажмите, чтобы добавить запись</u></td>
            </tr>
          </tbody>
        </table>
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    ptypes: store.ptypes
  }
}

export default connect(mapOrdersToProps, { fetchSets, addSets, sortSets, searchSets })(SetsPtype);



// WEBPACK FOOTER //
// ./src/components/settings/SetsPtype.js